import {connect} from "react-redux";
import {changeSelectedUrgency} from "./../actions/index";
import {getUrgencies, getSelectedUrgencyId} from "./../reducers/index";
import UrgencySelect from "../component/UrgencySelect";

const mapStateToProps = state => {
    return {
        urgencies: getUrgencies(state),
        value: getSelectedUrgencyId(state),
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onChange: selectedUrgencyId => {
            dispatch(changeSelectedUrgency(selectedUrgencyId))
        },
    }
}

const UrgencySelectContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(UrgencySelect)

export default UrgencySelectContainer
